import { ServiceWithStatus } from '../real-estate-asset-management.dto';

export interface ServiceWithDeal extends ServiceWithStatus {
    dealId: string;
    dealName: string;
    dealExternalId: string;
    dealClosingDate: string | null;
    /** True if this service is already mapped to the current REA. */
    alreadyAssigned: boolean;
}

export interface DealGroupForSelector {
    dealId: string;
    dealName: string;
    dealExternalId: string;
    dealClosingDate: string | null;
    services: ServiceWithDeal[];
}

/**
 * The type the one-service-per-REA rule (GEN-664) compares, mirroring the backend:
 * the HubSpot `service_key` (GEN-830 — tells the halves of a split product apart),
 * falling back to the sku for services without one. Null means the type is unknown
 * and the service is exempt from the rule.
 */
export function serviceTypeKey(service: Pick<ServiceWithStatus, 'serviceKey' | 'sku'>): string | null {
    return service.serviceKey ?? service.sku;
}

export function serviceLabel(service: ServiceWithStatus): string {
    const stage = service.pipelineStage?.pipelineStageName;
    return stage ? `${service.name} – ${stage}` : service.name;
}
